/**
 * @returns {string} api url
 */
export default function getStaticUrl(){
	return process.env.REACT_APP_API_URL
}
